/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InputReadAdminNotification } from '../models';
// @ts-ignore
import type { Notification } from '../models';
// @ts-ignore
import type { ResponseAdminReadNotification } from '../models';
/**
 * AdminNotificationApi - axios parameter creator
 * @export
 */
export const AdminNotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get all admin notifications without messages
         * @param {AllAdminNotificationsWithoutMessagesCategoryEnum} category 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allAdminNotificationsWithoutMessages: async (category: AllAdminNotificationsWithoutMessagesCategoryEnum, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('allAdminNotificationsWithoutMessages', 'category', category)
            const localVarPath = `/admin/notification/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark as read all notifications
         * @param {InputReadAdminNotification} [inputReadAdminNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAdminNotification: async (inputReadAdminNotification?: InputReadAdminNotification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notification/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputReadAdminNotification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNotificationApi - functional programming interface
 * @export
 */
export const AdminNotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get all admin notifications without messages
         * @param {AllAdminNotificationsWithoutMessagesCategoryEnum} category 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allAdminNotificationsWithoutMessages(category: AllAdminNotificationsWithoutMessagesCategoryEnum, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allAdminNotificationsWithoutMessages(category, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationApi.allAdminNotificationsWithoutMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark as read all notifications
         * @param {InputReadAdminNotification} [inputReadAdminNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readAdminNotification(inputReadAdminNotification?: InputReadAdminNotification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAdminReadNotification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readAdminNotification(inputReadAdminNotification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationApi.readAdminNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminNotificationApi - factory interface
 * @export
 */
export const AdminNotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNotificationApiFp(configuration)
    return {
        /**
         * 
         * @summary get all admin notifications without messages
         * @param {AllAdminNotificationsWithoutMessagesCategoryEnum} category 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allAdminNotificationsWithoutMessages(category: AllAdminNotificationsWithoutMessagesCategoryEnum, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Notification>> {
            return localVarFp.allAdminNotificationsWithoutMessages(category, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark as read all notifications
         * @param {InputReadAdminNotification} [inputReadAdminNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAdminNotification(inputReadAdminNotification?: InputReadAdminNotification, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAdminReadNotification> {
            return localVarFp.readAdminNotification(inputReadAdminNotification, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminNotificationApi - interface
 * @export
 * @interface AdminNotificationApi
 */
export interface AdminNotificationApiInterface {
    /**
     * 
     * @summary get all admin notifications without messages
     * @param {AllAdminNotificationsWithoutMessagesCategoryEnum} category 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationApiInterface
     */
    allAdminNotificationsWithoutMessages(category: AllAdminNotificationsWithoutMessagesCategoryEnum, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Notification>>;

    /**
     * 
     * @summary Mark as read all notifications
     * @param {InputReadAdminNotification} [inputReadAdminNotification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationApiInterface
     */
    readAdminNotification(inputReadAdminNotification?: InputReadAdminNotification, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAdminReadNotification>;

}

/**
 * AdminNotificationApi - object-oriented interface
 * @export
 * @class AdminNotificationApi
 * @extends {BaseAPI}
 */
export class AdminNotificationApi extends BaseAPI implements AdminNotificationApiInterface {
    /**
     * 
     * @summary get all admin notifications without messages
     * @param {AllAdminNotificationsWithoutMessagesCategoryEnum} category 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationApi
     */
    public allAdminNotificationsWithoutMessages(category: AllAdminNotificationsWithoutMessagesCategoryEnum, filter?: string, options?: RawAxiosRequestConfig) {
        return AdminNotificationApiFp(this.configuration).allAdminNotificationsWithoutMessages(category, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark as read all notifications
     * @param {InputReadAdminNotification} [inputReadAdminNotification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationApi
     */
    public readAdminNotification(inputReadAdminNotification?: InputReadAdminNotification, options?: RawAxiosRequestConfig) {
        return AdminNotificationApiFp(this.configuration).readAdminNotification(inputReadAdminNotification, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AllAdminNotificationsWithoutMessagesCategoryEnum = {
    Admin: 'admin',
    Caf: 'caf',
    Citizen: 'citizen'
} as const;
export type AllAdminNotificationsWithoutMessagesCategoryEnum = typeof AllAdminNotificationsWithoutMessagesCategoryEnum[keyof typeof AllAdminNotificationsWithoutMessagesCategoryEnum];
